module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('tickets-table', {
    attrs: {
      "site-id": _vm.rowData.site_id,
      "asset-id": _vm.assetId,
      "owner-id": _vm.rowData.organisation_id,
      "process-key": "equip-ticket",
      "hide-site": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-781ea2b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/EquipMaint.vue
// module id = 1571
// module chunks = 0